import * as React from 'react';
const regex = /<.*?\/>/gm;

// This is a helper function to break up a translated string
// that has control positions embedded in it.
// e.g. "Day <DAYNUM/> of every <INTERVAL/> months"
// Return an array of string fragments (and preserve spaces)
// e.g. ['Day ', '<DAYNUM/>', ' of every ', '<INTERVAL/>', ' months']
export const makeSentenceFragments = (sentence: string): string[] => {
    regex.lastIndex = 0; // Reset the regex

    const result: string[] = [];
    let lastIndex = 0;
    let match = regex.exec(sentence);
    if (!match) {
        throw new Error(`Found no embedded controls in ${sentence}`);
    }
    while (match) {
        if (match.index > lastIndex) {
            // Add text preceeding the tag
            result.push(sentence.substring(lastIndex, match.index));
        }

        // Add the tag
        result.push(match[0]);

        // Advance to next tag
        lastIndex = match.index + match[0].length;
        match = regex.exec(sentence);
    }
    
    // Add trailing text (if any)
    if (lastIndex < sentence.length) {
        result.push(sentence.substr(lastIndex));
    }
    return result;
};


export type ComponentMap = {
    [name: string]: React.ReactNode;
};

const fragmentComponentRegex = /^<(.*?)\/>$/;

// Helper function to render fragments of the translated sentence
// i.e. "Day <DAYNUM/> of every <INTERVAL/> month"
// This allows the input fields to be in different locations
// (relative to the sentence fragments) for different languages
export const renderFragment = (components: ComponentMap) => (fragment: string, i: number) => {
    const match = fragmentComponentRegex.exec(fragment);
    if (match) {
        const matchingComponent = components[match[1]];
        if (matchingComponent) {
            return React.createElement('span', { key: i }, matchingComponent);
        }
        else {
            throw new Error(`Failed to match fragment "${fragment}" in {${Object.keys(components).map(s => `"${s}"`).join(', ')}}`);
        }
    }

    return React.createElement('span', { key: i }, fragment);
};

export type FragmentRenderer = (fragment: string, i: number) => React.ReactNode;
    


// WEBPACK FOOTER //
// ./src/util/makeSentenceFragments.ts